import request from '@/utils/request';

export interface StsViewModel {
  securityToken: string;
  accessKeySecret: string;
  accessKeyId: string;
  expiration: Date;
  region: string;
  bucket: string;
}

export default class AliService {
  private serviceApi: string = 'Ali';

  public GetSTS() {
    return request({
      url: this.serviceApi,
      method: 'get',
    });
  }
  
}
